import { ProgressBar } from "react-bootstrap";

export type ImportProgressBarProps = { message: string; progress: number };

export default function ImportProgressBar(props: ImportProgressBarProps) {
    return (
        <label className="gap-1 d-flex flex-column w-100">
            {props.message}
            <ProgressBar
                style={{ height: "1.5rem" }}
                variant={props.progress == 100 ? "success" : undefined}
                now={props.progress}
                label={`${Math.round(props.progress)}%`}
            />
        </label>
    );
}
